module.exports = __webpack_public_path__ + "img/R4DM26 Annual Patch 2025 cropped.bed20847.png";